const BASE_URL = process.env.PATH_NAME
const DASHBOARD_URL = process.env.DASHBOARD_URL
const LEAD_REVIEW = process.env.LEAD_REVIEW

const addPath = parentFn => fn => {
  fn.path = () => `${parentFn()}/${fn()}`

  return fn
}

const passwordless = () => 'passwordless'

passwordless.identify = () => 'identificacao'
passwordless.identify.path = () =>
  `${passwordless()}/${passwordless.identify()}`

passwordless.accessCode = () => 'codigo-acesso'
passwordless.accessCode.path = () =>
  `${passwordless()}/${passwordless.accessCode()}`

passwordless.review = () => 'revisao'
passwordless.review.path = () => `${passwordless()}/${passwordless.review()}`

const password = () => 'password'

password.identify = () => 'identificacao'
password.identify.path = () => `${password()}/${password.identify()}`

password.selectClaim = () => 'selecionar-metodo-login'
password.selectClaim.path = () => `${password()}/${password.selectClaim()}`

password.accessCode = () => 'codigo-acesso'
password.accessCode.path = () => `${password()}/${password.accessCode()}`

password.enter = () => 'entrar'
password.enter.path = () => `${password()}/${password.enter()}`

const signup = () => 'cadastro'

const signupPath = addPath(signup)

signup.identify = signupPath(() => 'identificacao')

signup.document = signupPath(() => 'documento')

signup.email = signupPath(() => 'email')

signup.accessCode = signupPath(() => 'codigo-acesso')

const recovery = () => 'recuperar'

recovery.index = () => '/'
recovery.index.path = () => `${recovery()}`

recovery.emailSend = () => 'email-enviado'
recovery.emailSend.path = () => `${recovery()}/${recovery.emailSend()}`

const newPassword = () => 'nova-senha'
newPassword.index = () => '/'
newPassword.index.path = () => newPassword()
newPassword.validate = () => 'validacao'
newPassword.validate.path = () => `${newPassword()}/${newPassword.validate()}`

const createNewPassword = () => 'criar-nova-senha'
createNewPassword.index = () => '/'
createNewPassword.index.path = () => createNewPassword()
createNewPassword.validate = () => 'validacao'
createNewPassword.validate.path = () =>
  `${createNewPassword()}/${createNewPassword.validate()}`

const singleAuth = () => 'single-auth'
const successCreatePassword = () => 'senha-criada'
const invalidCreatePassword = () => 'email-criacao-invalido'
const invalidRecoveryPassword = () => 'email-recuperacao-invalido'
const createPassEmailSend = () => 'criar-senha/email-enviado'
const website = () => 'https://www.creditas.com'
const dashboard = () => DASHBOARD_URL
const leadReview = () => LEAD_REVIEW

const URLS = {
  BASE_URL,
  passwordless,
  password,
  signup,
  recovery,
  singleAuth,
  successCreatePassword,
  invalidCreatePassword,
  invalidRecoveryPassword,
  createPassEmailSend,
  newPassword,
  createNewPassword,
  website,
  dashboard,
  leadReview,
}

export { URLS }
